module.exports = __webpack_public_path__ + "eb45a68ab4c8d154c69396d27d5721be.png";